export default {
    items: [
        // {
        //     name: 'Договора ОО', // НСБ › Система › Юридический отдел
        //     url: '/jur/drivers',
        //     icon: 'icon-puzzle'
        // },
    ]
}

